import React from 'react';
type AvatarProps = {
  name: string;
  src?: string;
  color?: string;
  className?: string;
};

/** Photo when available, otherwise an initials badge in the product palette. */
export function Avatar({
  name,
  src,
  color = 'bg-grass-deep',
  className = ''
}: AvatarProps) {
  if (src) {
    return <img src={src} alt={name} loading="lazy" className={`rounded-full object-cover ${className}`} data-id="element-51" data-mp="1zoajq1xp5ig" />;
  }
  const initials = name.replace(/[^A-Za-z ]/g, '').split(' ').filter(Boolean).map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'NQ';
  return <span aria-label={name} className={`flex items-center justify-center rounded-full font-display text-sm font-bold text-white ${color} ${className}`} data-id="element-52" data-mp="gwnp5xv7dymf">
      {initials}
    </span>;
}